import React from 'react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
const pains = [{
  icon: '😩',
  text: 'Probaste mil dietas y siempre terminás abandonando a la semana'
}, {
  icon: '💸',
  text: 'Gastaste en gimnasios que nunca usás porque la rutina te abruma'
}, {
  icon: '⏰',
  text: 'Sentís que no tenés tiempo para hacer ejercicio entre el trabajo y la familia'
}, {
  icon: '😰',
  text: 'Querés moverte pero no sabés por dónde empezar sin hacerte daño'
}, {
  icon: '📉',
  text: 'Ves resultados lentos, te frustrás y abandonás antes de llegar a la meta'
}, {
  icon: '🚶',
  text: 'Ya caminás, pero no sabés cómo hacerlo para quemar grasa de verdad'
}];
export function PainPoints() {
  return <section className="w-full bg-cream" data-id="element-143" data-mp="1sxva0pej9luq">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-24" data-id="element-144" data-mp="1t0r6086tm0gj">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-145" data-mp="3iemle069879m">
          <h2 className="font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-146" data-mp="3nco068wndkfa">
            ¿Te sentís identificado/a?
          </h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-147" data-mp="1yzn3xk05p8g3">
            ¿Cuántas veces intentaste bajar de peso y volviste al punto de partida?
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-148" data-mp="27sz0w31fjouw">
          {pains.map((p, i) => <Reveal key={p.text} delay={i % 2 * 0.08} data-id="element-149" data-mp="23rnc1zqdr7nr" data-mpi={i}>
              <div className="flex h-full items-start gap-4 rounded-2xl border border-ink/10 bg-white p-5 shadow-sm" data-id="element-150" data-mp="23s6sfc0dtnzo">
                <span className="text-2xl leading-none" data-id="element-151" data-mp="1g3nkwyp5pf8n">{p.icon}</span>
                <p className="text-base leading-relaxed text-ink/80" data-id="element-152" data-mp="1b4ap3ogb4xtx">{p.text}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal className="mt-12 text-center" data-id="element-153" data-mp="1k3nzcjc99qfp">
          <p className="mx-auto max-w-2xl text-lg font-medium text-ink" data-id="element-154" data-mp="1k1uqcxe66u4j">
            Si dijiste sí a alguno de estos puntos, este programa es exactamente para vos.
          </p>
          <div className="mt-7" data-id="element-155" data-mp="2vhjdborfbt5c">
            <CtaButton data-id="element-156" data-mp="2vibb968hu2ys">SÍ, QUIERO TRANSFORMARME</CtaButton>
          </div>
        </Reveal>
      </div>
    </section>;
}